import React from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import styles from "./styles";

interface EndChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  metadata?: {
    header: string;
    button: string;
    body: string;
  }
  width?: number,
}

const EndChatModal: React.FC<EndChatModalProps> = ({ isOpen, onClose, onConfirm, metadata, width }) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={width? {...styles.modalContainer, width: width} : styles.modalContainer}>
        <Typography variant="h6" sx={styles.modalHeader}>
          {metadata ? metadata.header : "ARE YOU SURE YOU WANT TO END THIS CHAT?"}
        </Typography>
        <Typography variant="body2" sx={styles.modalBody}>
          {metadata ? metadata.body : "Proceeding with this action will delete the current conversation."}
        </Typography>
        <Box sx={styles.modalActions}>
          <Button
            variant="text"
            color="primary"
            sx={styles.modalButton}
            onClick={onClose}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={styles.modalButton}
            onClick={onConfirm}
          >
            {metadata ? metadata.button : "END CHAT"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EndChatModal;
